import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { getUserInfo } from "@/api/common.js"
import { useStore } from "vuex"
import { useRouter } from 'vue-router';

export default /*@__PURE__*/_defineComponent({
  __name: 'paySuccess',
  setup(__props) {

const store = useStore();
const router = useRouter()
function backEvent() {
    getUser(() => {
        router.go(-1)
    })
}

function getUser(cb) {
    getUserInfo().then(res => {
        store.dispatch('setLogin', res.data);
        cb && cb()
    })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _cache[0] || (_cache[0] = _createTextVNode(" 支付成功 ")),
    _createElementVNode("div", { onClick: backEvent }, "返回")
  ]))
}
}

})